module.exports = __webpack_public_path__ + "static/media/repeatable-header-footer-off-preview.f60b136b.png";